import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';


@inject('Game3Store')
@observer
export default class Game3Step6 extends Component {

    static defaultProps = {
        onChangeAnswer: () => {},
    };

    constructor(props) {
        super(props);
    }

    addPointsToScore(index, player, bonus , e) {

        let points = bonus.points;

        if( player.bonus === undefined ) {
            player.score += points;
            player.bonus = points;
        } else if ( player.bonus !== undefined ) {
            player.score = player.score - player.bonus;
            player.score += points;
            player.bonus = points;
        }

        const btns = document.querySelectorAll(".btn-answer."+player.team.name);
        for (let bt of btns) {
            bt.className = "btn-answer "+player.team.name;
            if (bt.name === "btn" + index) {
                bt.className =  "btn-answer " +player.team.name + " selected";
            }
        }

        let length = this.props.Game3Store.players.length;
        setTimeout(function () {
            let selected = document.querySelectorAll(".selected");

            if( selected.length == length) {
                const btnNavNext = document.querySelector(".btn-nav-next");
                btnNavNext.className = "btn-nav-next";
            }
        },100);
    }

    render() {

        let players = this.props.Game3Store.players;

        let bonusPoints = this.props.Game3Store.bonusPoints;

        let _this = this;

        var taskEl = [];

        players.forEach(function(player){

            const bonusEl = bonusPoints.map(
                (bonus, index) =>
                    <button
                        name={"btn" + index}
                        className={"btn-answer " + player.team.name}
                        key={index}
                        onClick={_this.addPointsToScore.bind(_this, index, player, bonus)}>{bonus.label}
                    </button>
            );

            taskEl.push(
                <div className="team-name" key={player.name}>
                    <label className={player.team.color}>{player.name}</label>
                    <br/>
                    <div className="dropdown-inline">
                        {bonusEl}
                    </div>
                    <br/>
                </div>
            );

        });


        return (
            <div className="step-4">
                <ScoreBar players={this.props.Game3Store.players}/>
                <h1>Game</h1>
                <br/><br/><br/><br/><br/><br/>
                <div className="teams">
                    {taskEl}
                </div>
            </div>
        )
    }
};

const ScoreBar = ({players = []}) => {

    const scores = players.map(
        (player, index) => (
            <Score key={index} player={player} />
        )
    );

    return (
        <div className="ScoreBar">
            {scores}
        </div>
    )
};

const Score = ({player}) => {
    return (
        <div className="Score">
            <div className={"team-name " + player.team.color}>{player.name}</div>
            <div>{player.score} Points</div>
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/containers/Game3/Game3Step6.js